import styled, { css } from "styled-components";

import { blink } from "../theme/keyframes";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Dot = styled.span<Props>`
  height: 12px;
  width: 12px;
  background-color: ${({ theme }) =>
    theme.customThemeOptions.colors.primary} !important;
  border-radius: 50%;
  ${({ duration }) => css`
    animation: ${duration}ms ${blink} infinite;
  `}
  ${({ numberOfDots, duration }) =>
    Array.from(
      { length: numberOfDots },
      (x, i) => `&:nth-child(${i + 1}) {
    animation-delay: ${duration * (i / numberOfDots)}ms;
    ${i < numberOfDots ? "margin: 0 15px 0 0;" : ""}
  }`
    ).join(" ")}
`;

const MovingDots = ({ duration, numberOfDots }: Props) => {
  const dots = Array.from({ length: numberOfDots }, (x, i) => (
    <Dot key={i.toString()} numberOfDots={numberOfDots} duration={duration} />
  ));
  const style = Array.from(
    { length: numberOfDots },
    (x, i) => `&:nth-child(${i + 1}) {
    animation-delay: ${duration * (i / numberOfDots)}ms;
    ${i < numberOfDots ? "margin: 0 0 0 15px;" : ""}
  }`
  ).join(" ");
  return <Container>{dots}</Container>;
};

interface Props {
  duration: number;
  numberOfDots: number;
}

export default MovingDots;
